import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  ViewChildren,
  QueryList,
  Input,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { addDays, addMonths, format, parse, startOfToday } from 'date-fns';
import { IListViewsPlanning } from '@shared/interfaces/list-views-planning';
import { DayPlanning } from '@shared/interfaces/planning/day-planning.interface';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BookingDialogComponent } from '@shared/components/booking-dialog/booking-dialog.component';
import { environment } from 'src/environments/environment';
import { ApiService } from '@shared/services/api.service';
import { es } from 'date-fns/locale';
import { parseISO } from 'date-fns';
import { PrimeNGConfig } from 'primeng/api';
import { GeneralPlanningService } from '../services/general-planning.service';

type SelectedDateService = {
  date: string;
  planning_group: string;
  hour?: string;
};

@Component({
  selector: 'app-planning-meetings',
  templateUrl: './planning-meetings.component.html',
  styleUrls: ['./planning-meetings.component.scss'],
  providers: [DialogService],
})
export class PlanningMeetingsComponent {
  @Input() selectedDate: Date = new Date();
  @ViewChild('filterSelectServices') filterSelectServices!: ElementRef;
  @ViewChildren('rowDate') rows!: QueryList<ElementRef>;
  @ViewChild('tableMonthContainer') tableMonthContainer!: ElementRef;

  spanishLocale: any;

  occupiedCells: boolean[][] = [];
  planningData: DayPlanning[] = [];
  selectedItems: any[] = [];
  // currentMonth: number;
  // currentYear: number;
  showCalendar: boolean = false;
  canChangeStatusService: boolean = true;
  monthData: any[] = [];
  hourData: any[] = [];
  filteredHourData: any[] = [];
  warehouseItems: any[] = [];
  // viewTab: IListViewsPlanning = {
  //   hours: false,
  //   days: false,
  //   months: true,
  // };
  activeIndex: number = 0;
  tabs: string[] = ['bookedToday', 'planning'];
  showBtnCalendar: boolean = false;
  ref: DynamicDialogRef | null = null;
  selectedDateService: SelectedDateService[] = [];
  planningGroupNames: string[] = [];
  filteredMonthData: any[] = [];
  listDatesUnavailables: any = [];
  drumsAndItemsByBooking: any[] = [];
  isFirstLoadByHour: boolean = false;
  environment: any = environment;

  constructor(
    private http: HttpClient,
    private primengConfig: PrimeNGConfig,
    private elRef: ElementRef,
    private dialogService: DialogService,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef
  ) {
    // const currentDate = new Date();
    // this.currentMonth = currentDate.getMonth() + 1;
    // this.currentYear = currentDate.getFullYear();
  }

  ngOnInit() {
    let roles = JSON.parse(localStorage.getItem('me') ?? '')?.roles;

    if (roles) {
      if (roles.includes('super-admin') || roles.includes('manager')) {
        this.canChangeStatusService = true;
      } else {
        this.canChangeStatusService = false;
      }
    } else {
      this.canChangeStatusService = false;
    }
    this.initializeOccupiedCells();
    this.loadDayData();

    setInterval(() => {
      this.loadDayData();
    }, 15000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate']) {
      this.selectedDate = changes['selectedDate'].currentValue;
      this.loadDayData();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.scrollToCurrentDate(), 1000);
  }

  initializeOccupiedCells() {
    this.occupiedCells = this.hourData.map(() =>
      this.planningGroupNames.map(() => false)
    );
  }

  loadMonthData(): void {
    const month = format(this.selectedDate, 'MM');
    const year = format(this.selectedDate, 'yyyy');
    const postData = { month, year };

    this.http
      .post(`${environment.baseUrl}/planning/takepoints/month`, postData)
      .subscribe((data: any) => {
        this.selectedDateService = data;
        console.log('data bookings:', data);
        this.monthData = data;
        this.filteredMonthData = data;
        this.filterByService();
        this.populatePlanningGroupNames();
      });
  }

  loadDayData(): void {
    const date = format(this.selectedDate, 'yyyy-MM-dd');
    this.http
      .post(`${environment.baseUrl}/planning/takepoints/day`, { date })
      .subscribe(
        (data: any) => {
          console.log('data hour:', data);
          this.hourData = data;
          this.filteredHourData = data;
        },
        (error) => {
          console.error('Error loading hour data:', error);
        }
      );
  }

  getLocationData(address: string, data: any){
    
    if(data['locations'] && data['locations'].length > 0){
      let location = data['locations'].find((location: any) => location.location === address);

      if(location){
        return location['total'];
      }
    }
    return 'Sin recogidas';
  }

  toggeBlockDate(hour: string, groupName: string) {
    let fullDateString = this.getFullDate(hour);
    let isBlocked: boolean = this.getGroupServices(hour, groupName).is_blocked;

    let group = this.getGroupServices(hour, groupName);

    group.is_blocked = !group.is_blocked;

    if (group.is_blocked) {
      this.apiService
        .post('/service/set-date-unavailable', {
          date_time: fullDateString,
          service: groupName,
        })
        .subscribe((response: any) => {});
    } else {
      console.log('isNotBlocked');
      this.apiService
        .get(`/service/delete-date-unavailable/${fullDateString}/${groupName}`)
        .subscribe((response: any) => {});
    }
  }

  getFullDate(hour: string) {
    let selectedDateString = format(this.selectedDate, 'yyyy-MM-dd', {
      locale: es,
    });

    let selectedHourDate = parse(hour, 'HH:mm', new Date(), {
      locale: es,
    });

    let selectedHourString = format(selectedHourDate, 'HH:mm:ss', {
      locale: es,
    });
    return `${selectedDateString} ${selectedHourString}`;
  }

  initializeSelectedDateServiceByHour() {
    this.selectedDateService = [];
    this.filteredHourData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        this.selectedDateService.push({
          date: this.formatDate(this.selectedDate),
          hour: hour.hour,
          planning_group: group.group_name,
        });
      });
    });
  }

  initializeSelectedDateServiceByMonth() {
    this.selectedDateService = [];
    this.filteredMonthData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        this.selectedDateService.push({
          date: this.formatDate(this.selectedDate),
          hour: hour.hour,
          planning_group: group.group_name,
        });
      });
    });
  }

  checkSelectedDateService(
    date: string,
    groupName: string,
    hour?: string | boolean
  ): boolean {
    let existsDateHour = false;
    if (hour) {
      existsDateHour = this.selectedDateService.some((dateHour: any) => {
        return (
          dateHour.date == date &&
          dateHour.planning_group == groupName &&
          dateHour.hour == hour
        );
      });
    } else {
      existsDateHour = this.selectedDateService.some((dateHour: any) => {
        return dateHour.date == date && dateHour.planning_group == groupName;
      });
    }
    return existsDateHour;
  }

  markOccupiedCells(startIndex: number, colIndex: number, duration: number) {
    for (let i = 0; i < duration; i++) {
      if (this.occupiedCells[startIndex + i]) {
        this.occupiedCells[startIndex + i][colIndex] = true;
      }
    }
  }

  isCellOccupied(rowIndex: number, colIndex: number): boolean {
    return (
      this.occupiedCells[rowIndex] && this.occupiedCells[rowIndex][colIndex]
    );
  }

  hasGroupStartingAt(hour: string, groupName: string): boolean {
    const index = this.hourData.findIndex((h: any) => h.hour === hour);
    if (index === -1) return false;
    return this.hourData[index].planning_group.some(
      (group: any) =>
        this.isFirstHour(group.start_hour, hour) &&
        group.group_name === groupName
    );
  }

  getGroupDuration(hour: string, groupName: string): number {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return 1;
    const group = hourData.planning_group.find((g: any) => {
      console.log('hours', g.start_hour, hour);
      return g.group_name === groupName && this.isFirstHour(g.start_hour, hour);
    });

    let duration = group ? group.duration : 1;
    duration = duration * 2;
    // if(duration > 1){
    //   duration = (duration * 2)+1;
    // }else if(duration == 1){
    //   duration = (duration * 2);
    // }

    if (group) {
      const rowIndex = this.hourData.findIndex((h: any) => h.hour === hour);
      const colIndex = this.planningGroupNames.indexOf(groupName);
      this.markOccupiedCells(rowIndex, colIndex, duration);
    }
    return duration;
  }

  getGroupTotalTickets(hour: string, groupName: string): number {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return 0;

    const group = hourData.planning_group.find(
      (g: any) =>
        g.group_name === groupName && this.isFirstHour(g.start_hour, hour)
    );
    return group ? group.total_tickets : 0;
  }

  getGroupServices(hour: string, groupName: string): any {
    const hourData = this.hourData.find((h: any) => h.hour === hour);
    if (!hourData) return { services: [], groups: [], takepoints: [] };
    const group = hourData.planning_group.find(
      (g: any) =>
        g.group_name === groupName && this.isFirstHour(g.start_hour, hour)
    );
    return group || { services: [], groups: [], takepoints: [] };
  }

  isFirstHour(startHour: string, currentHour: string): boolean {
    return startHour === currentHour;
  }

  isPastDate(date: string): boolean {
    let currentDate = startOfToday();
    const targetDate = parseISO(date);
    return (
      targetDate < currentDate &&
      targetDate.toDateString() !== currentDate.toDateString()
    );
  }

  scrollToCurrentDate(): void {
    const firstNonPastRow = this.rows.find((row) => {
      return !row.nativeElement.classList.contains('past-date');
    });

    if (firstNonPastRow && this.tableMonthContainer) {
      firstNonPastRow.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  selectDateOnCalendar(event: any) {
    this.selectedDate = event;
    this.selectedDateService = [];
    this.loadDayData();
  }

  manageCalendar(event: any) {
    event.preventDefault();
    this.showCalendar = !this.showCalendar;
  }

  onChangeTab(event: any) {
    if (this.tabs[this.activeIndex] == 'planning') {
      this.showBtnCalendar = true;
    } else {
      this.showBtnCalendar = false;
    }
  }

  resetDateSelector() {
    this.selectedDate = new Date();
    this.loadDayData();
  }

  moveDate(position: number) {
    this.selectedDate = addDays(this.selectedDate, position);
    this.loadDayData();
  }

  populatePlanningGroupNames(): void {
    const groupNamesSet = new Set<string>();
    this.monthData.forEach((day) => {
      day.planning_group.forEach((group: any) => {
        groupNamesSet.add(group.group_name);
      });
    });
    this.hourData.forEach((hour) => {
      hour.planning_group.forEach((group: any) => {
        groupNamesSet.add(group.group_name);
      });
    });
    this.planningGroupNames = Array.from(groupNamesSet);
  }

  filterByService(event?: any): void {
    const selectedService = this.filterSelectServices.nativeElement.value;
    if (selectedService === 'all') {
      this.filteredMonthData = this.monthData;
      this.filteredHourData = this.hourData;
    } else {
      this.filteredHourData = this.hourData.map((hour) => {
        const filteredGroup = hour.planning_group.filter(
          (group: any) => group.group_name === selectedService
        );
        return { ...hour, planning_group: filteredGroup };
      });

    }
    if (this.isFirstLoadByHour) {
      this.initializeSelectedDateServiceByHour();
      this.isFirstLoadByHour = false;
    }
  }

  openBookingByDateServiceDialog(
    date: string,
    groupName: string,
    hour?: string
  ) {
    const postData: { date: string; groupName: string; hour?: string } = {
      date,
      groupName: groupName,
    };

    if (hour) {
      postData.hour = hour;
      console.log('hour', hour);
    }
    this.http
      .post(`${environment.baseUrl}/planning/address/bookings`, postData)
      .subscribe((data: any) => {
        console.log('data bookings:', data);
        const header = hour
          ? `Reservas para ${groupName} en ${date} a las ${hour}`
          : `Reservas para ${groupName} en ${date}`;
        this.ref = this.dialogService.open(BookingDialogComponent, {
          data: {
            bookings: data,
          },
          header: header,
          width: '95%',
          // contentStyle: { maxWidth: '900px', width: '95%' }
        });
      });
  }

  formatDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
  }
}
